/* eslint react/prop-types: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noop } from 'lodash';
import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { ShiftDigitalService } from '@sm360/widget-commons-general';

import * as Actions from 'build-and-quote/actions/buildAndQuoteActions.js';

const StepButton = ({ actions, nextSection, currentSection, extraClass, onClick }) => {
    const isPreviousButton = nextSection && currentSection && nextSection.value < currentSection;
    const btnStyleClasses = ['btn-step'];
    const windowGet = WindowProxy.get();

    btnStyleClasses.push(isPreviousButton ? 'previous sr-button-1' : 'next sr-button-1 is-darker');

    btnStyleClasses.push(extraClass);

    const scrollToTakeAction = () => {
        onClick();
        if (nextSection.scrollSection && windowGet) {
            ShiftDigitalService.createBuilderPageViewEvent();
            const nav = windowGet.document.getElementById('build-and-price__nav');
            if (nav) {
                nav.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }

        actions.changeBuildAndQuoteSection(nextSection.value);
    };

    return (
        <button className={btnStyleClasses.join(' ')} onClick={scrollToTakeAction}>
            <icon className="icon-Arrow-Left-2" />
            {isPreviousButton ? LocaleService.t('PREVIOUS_SLIDE') : LocaleService.t('NEXT_SLIDE')}
        </button>
    );
};

StepButton.defaultProps = {
    extraClass: '',
    onClick: noop,
};

StepButton.propTypes = {
    nextSection: PropTypes.shape({
        value: PropTypes.number.isRequired,
        transKey: PropTypes.string.isRequired,
    }).isRequired,
    currentSection: PropTypes.number.isRequired,
    actions: PropTypes.shape({
        changeBuildAndQuoteSection: PropTypes.func.isRequired,
    }).isRequired,
    extraClass: PropTypes.string,
    onClick: PropTypes.func,
};

StepButton.displayName = 'StepButton';

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export { StepButton };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StepButton);
